import { useMutation } from 'react-relay';

import { hometaxLoginMutation } from '@/__generated__/hometaxLoginMutation.graphql';
import { hometaxLogin } from '@/graphql/mutation/taxRefund/hometaxLogin';

export const useHometaxLogin = () => {
  const [commit, isInFlight] = useMutation<hometaxLoginMutation>(hometaxLogin);

  return { commit, isInFlight };
};
